import React, { useState } from "react";
import { Link } from "react-router-dom";
import { Mail, ShieldCheck } from "lucide-react";
import { toast } from "sonner";
import { formatApiError } from "../../lib/api";
import { mk, setMarketToken } from "../../lib/market";

export function EmailGate({ onDone }) {
  const [email, setEmail] = useState("");
  const [code, setCode] = useState("");
  const [step, setStep] = useState("email");
  const [busy, setBusy] = useState(false);
  async function send(e) {
    e.preventDefault();
    setBusy(true);
    try {
      const { data } = await mk.post("/market/access/code", { email });
      setStep("code");
      if (data.mocked) toast.message(`Email sending is in test mode. Your code is ${data.dev_code}`, { duration: 15000 });
      else toast.success("Check your inbox for a 6-digit code");
    } catch (err) { toast.error(formatApiError(err)); } finally { setBusy(false); }
  }
  async function verify(e) {
    e.preventDefault();
    setBusy(true);
    try {
      const { data } = await mk.post("/market/access/verify", { email, code });
      setMarketToken(data.token);
      toast.dismiss();
      onDone();
    } catch (err) { toast.error(formatApiError(err)); } finally { setBusy(false); }
  }
  return (
    <div className="max-w-md mx-auto bg-white border border-[var(--line)] rounded-3xl p-8 text-center" data-testid="market-gate">
      <ShieldCheck className="w-10 h-10 text-[var(--gold)] mx-auto" />
      <p className="font-serif text-3xl mt-3">Step inside the market</p>
      <p className="text-sm text-[var(--muted)] mt-2">Confirm your email once to save items, message sellers and check out.</p>
      {step === "email" ? (
        <form onSubmit={send} className="mt-6 space-y-3">
          <input type="email" required value={email} onChange={(e) => setEmail(e.target.value)} placeholder="you@email.com" className="input-luxe" data-testid="market-gate-email" />
          <button disabled={busy} className="btn-gold w-full" data-testid="market-gate-send"><Mail className="w-4 h-4" /> {busy ? "Sending…" : "Email me a code"}</button>
        </form>
      ) : (
        <form onSubmit={verify} className="mt-6 space-y-3">
          <input inputMode="numeric" maxLength={6} required value={code} onChange={(e) => setCode(e.target.value.replace(/\D/g, ""))} placeholder="6-digit code" className="input-luxe text-center tracking-[0.5em] text-xl" data-testid="market-gate-code" />
          <button disabled={busy || code.length !== 6} className="btn-gold w-full" data-testid="market-gate-verify">{busy ? "Checking…" : "Enter the market"}</button>
          <button type="button" onClick={() => setStep("email")} className="text-xs text-[var(--muted)] underline">Use a different email</button>
        </form>
      )}
      <p className="text-xs text-[var(--muted)] mt-6">Have an account? <Link to="/login" className="text-[var(--gold)] underline">Log in</Link> to browse and sell.</p>
    </div>
  );
}
